// export const BASE_URL = "http://apiht.smilexl.cn/"; // 正式地址
export const BASE_URL = "https://signapi.nutrition-esthetics.com"; // 正式地址
// export const BASE_URL = ""; // 测试地址

export const TOKEN_KEY = "USER_TOKEN"; // 用户token，由后台生成

export function setToken(token) {
  return localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function removeToken() {
  return localStorage.removeItem(TOKEN_KEY);
}

export function setUserInfo(data) {
  return localStorage.setItem("USER_INFO", JSON.stringify(data));
}

export function getUserInfo() {
  let userInfo = localStorage.getItem("USER_INFO");
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
  }
  return userInfo;
}

export function removeUserInfo() {
  return localStorage.removeItem("USER_INFO");
}

export const VERSION = "1.0.0";



// WEBPACK FOOTER //
// ./src/utils/auth.js